import {
    Box,
    FormLabel,
    Grid,
    IconButton,
    Stack,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextareaAutosize,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
  } from "@mui/material";
  import { DataGrid } from "@mui/x-data-grid";
  import { useSelector } from "react-redux";
  import format from "date-fns/format";
  import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
  import { getBankReconciliationTable } from "../../Services/api";
  import { useEffect, useState } from "react";
  import instance from "../../redux/api";
  import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
  import { CommonButton } from "../common/commonButton";
  import CustomDateRangePicker from "../common/CustomDateRangePicker";
  import FilterListIcon from "@mui/icons-material/FilterList";
  import "../common/commonPageStyles.css";
  import {
    numberFormatter,
  } from "../../utils/generalFunctions";
  import PanoramaFishEyeRoundedIcon from "@mui/icons-material/PanoramaFishEyeRounded";
  import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
  import "../../assets/scss/common.scss";
  import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
  import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
  import dayjs from "dayjs";
  import { toast } from "react-toastify";
  
  import { commonToast } from "../common";
  
  export const BankReconciliationView = () => {
    const toggle = useSelector((state) => state.toggleSideMenu);
    const accountsList = useSelector(
      (state) => state?.bankStatmentTransactions?.accountsList
    );
  
    const { userData } = useSelector((state) => state?.user);
  
    const [searchFieldsPrams, setSearchFieldsPrams] = useState({
      Bank_Name: "",
      Receiving_Bank_Account: "",
      Entity: "",
      Bank_Currency: ""
    });
  
    const [tabValue, setTabValue] = useState(1);
  
    //For Date picker
    const [fromDateValue, setFromDateValue] = useState("");
    const [toDateValue, setToDateValue] = useState("");
  
    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const [isClearPerformed, setIsClearPerformed] = useState(false);
    const [isBankAccountNoDeSelected, setIsBankAccountNoDeSelected] =
      useState(false);
  
    //For pagination
    const [paginationCount, setPaginationCount] = useState(0);
    const [pageState, setPageState] = useState({
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      pageSize: 25,
    });
  
    const [openCommentsDialog, setOpenCommentsDialog] = useState(null);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [dialogCommentsValue, setDialogCommentsValue] = useState("");
    const [oldConcatenatedComment, setOldConcatenatedComment] = useState("");

    // Summary States
    const [totalCreditAmount, setTotalCreditAmount] = useState();
    const [totalDebitAmount, setTotalDebitAmount] = useState();
    const [totalCashTrackerAmount, setTotalCashTrackerAmount] = useState();
    const [totalVariance, setTotalVariance] = useState();

    // Filter search states
    const [bankNameSearch, setBankNameSearch] = useState("");
    const [accountNoSearch, setAccountNoSearch] = useState("");
    const [selectedBanks, setSelectedBanks] = useState([]);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);
  
  
    // skip 0 means page 1
    const currentSkipNumber = () => {
      return pageState?.page === 1
        ? 0
        : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
    };
  
  
    useEffect(() => {
      setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
    }, [pageState?.total]);
  
  
    const loadData = async () => {
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
  
        let queryParams = `skip=${currentSkipNumber()}&pageSize=${
          pageState?.pageSize
        }`;
  
        if (isSearchPerformed) {
          const getSearchQueryParam = searchQueryParams();
          if (getSearchQueryParam) {
            queryParams = `${queryParams}${getSearchQueryParam}`;
          }
        }
  
        const response = await instance.get(
          `${getBankReconciliationTable}?variance=1&${queryParams}`
        );
        const data = response.data;
        const secdata = data.summary;
        setTotalCreditAmount(secdata.total_credit_amount || 0.0);
        setTotalDebitAmount(secdata.total_debit_amount || 0.0);
        setTotalCashTrackerAmount(secdata.total_ca_rec_amount || 0.0);
        setTotalVariance(secdata.total_variance || 0.0);
  
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        handleVarianceResponse(response);
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
        setPaginationCount(0);
        console.error("err", err);
      }
    };
  
    const handleClearSearchList = async () => {
      // Clear all filter states
      setSelectedBanks([]);
      setSelectedAccounts([]);
      setBankNameSearch("");
      setAccountNoSearch("");
      setIsClearPerformed(true);
      setIsSearchPerformed(false);
      // clear fields
      setSearchFieldsPrams({
        Bank_Name: "",
        Receiving_Bank_Account: "",
        Entity: "",
        Bank_Currency: ""
      });
      getBankAccountsList("");
      setFromDateValue("");
      setToDateValue("");
    };
  
    const isFilterBtnDisable = () => {
      let disabled = true;
      const { Entity, Bank_Currency } = searchFieldsPrams;
      if (
        selectedBanks.length > 0 ||
        selectedAccounts.length > 0 ||
        fromDateValue !== "" ||
        toDateValue !== "" ||
        Entity !== "" ||
        Bank_Currency !== ""
      ) {
        disabled = false;
      }
      return disabled;
    };
  
    const classes = useStyles();
  
    const handleVarianceResponse = (response) => {
      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
  
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    };
  
    const handleTabChange = async (event, newValue) => {
      setTabValue(newValue);
  
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
  
        const response = await instance.get(
          `${getBankReconciliationTable}?variance=${newValue}&skip=${currentSkipNumber()}&pageSize=${
            pageState?.pageSize
          }`
        );
  
        const data = response.data;
        const secdata = data.summary;
        setTotalCreditAmount(secdata.total_credit_amount || 0.0);
        setTotalDebitAmount(secdata.total_debit_amount || 0.0);
        setTotalCashTrackerAmount(secdata.total_ca_rec_amount || 0.0);
        setTotalVariance(secdata.total_variance || 0.0);
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        handleVarianceResponse(response);
      } catch {
        setPageState((old) => ({
          ...old,
          isLoading: false,
          total: 0,
          data: [],
        }));
      }
    };
  
    const columns = [
      {
        headerName: "",
        width: 50,
        headerAlign: "center",
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <RadioButtonCheckedIcon
            sx={{
              color: params?.row?.migrated_data == 1 ? "#808080" : "#1672DE",
            }}
          />
        ),
      },
      {
        field: "Payment_Receive_Date",
        headerName: "Payment Received Date",
        headerAlign: "center",
        width: 170,
        valueFormatter: (params) => {
          // Format the date using date-fns or any other date formatting library
          return customDateFormat(params.value);
        },
      },
      {
        field: "entity_name",
        headerName: "Entity",
        headerAlign: "center",
        width: 80,
        valueGetter: (params) => params?.row?.entity_name,
        renderCell: (params) => (
          <Tooltip title={params?.row?.entity_name}>
            <span>{params?.row?.entity_number?.substr(0, 10)}</span>
          </Tooltip>
        ),
      },
      {
        field: "currency",
        headerName: "Bank Currency",
        headerAlign: "center",
        width: 130,
        valueGetter: (params) => params?.row?.currency,
        renderCell: (params) => {
          return <span>{params?.row?.currency}</span>;
        },
      },
      {
        field: "Receiving_Bank_Account",
        headerName: "Bank Account",
        headerAlign: "center",
        width: 110,
      },
      {
        field: "total_credit_amount",
        headerName: "Bank Stmt Amount(CR)",
        headerAlign: "center",
        width: 175,
        valueFormatter: (params) => {
          return numberFormatter(params.value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_debit_amount",
        headerName: "Bank Stmt Amount(DR)",
        headerAlign: "center",
        width: 175,
        valueFormatter: (params) => {
          return numberFormatter(params.value);
        },
        cellClassName: "amount-table-cell",
      },
    //   {
    //     field: "ct_amount",
    //     headerName: "Amt on Cash Tracker (Allocated amt)",
    //     headerAlign: "center",
    //     width: 250,
    //     valueFormatter: (params) => {
    //       return numberFormatter(params.value);
    //     },
    //     cellClassName: "amount-table-cell",
    //   },
    //   {
    //     field: "ct_amount_car",
    //     headerName: "Variance (Allocated amt)",
    //     headerAlign: "center",
    //     width: 180,
    //     valueFormatter: (params) => {
    //       return numberFormatter(params.value);
    //     },
    //     cellClassName: "amount-table-cell",
    //   },
      {
        field: "ca rec amt",
        headerName: "Amt on Cash Tracker (Receivable amt)",
        headerAlign: "center",
        width: 250,
        valueFormatter: (params) => {
          const value = params.value !== undefined ? params.value : 0;
          return numberFormatter(isNaN(value) ? 0 : value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "variance",
        headerName: "Variance (Receivable amt)",
        headerAlign: "center",
        width: 180,
        valueFormatter: (params) => {
          const value = params.value !== undefined ? params.value : 0;
          return numberFormatter(isNaN(value) ? 0 : value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "bank_charges",
        headerName: "Bank Charges (CR)",
        headerAlign: "center",
        width: 165,
        valueFormatter: (params) => {
          const value = params.value !== undefined ? params.value : 0;
          return numberFormatter(isNaN(value) ? 0 : value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ct_bank_charges",
        headerName: "Bank Charges (CT)",
        headerAlign: "center",
        width: 165,
        valueFormatter: (params) => {
          const value = params.value !== undefined ? params.value : 0;
          return numberFormatter(isNaN(value) ? 0 : value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ct_bank_charges_var",
        headerName: "Bank Charges (Var)",
        headerAlign: "center",
        width: 165,
        valueFormatter: (params) => {
          const value = params.value !== undefined ? params.value : 0;
          return numberFormatter(isNaN(value) ? 0 : value);
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ct_category",
        headerName: "Category",
        headerAlign: "center",
        width: 130,
        flex: 0,
        valueFormatter: (params) => {
          return params.value !== undefined ? params.value : "N/A";
        },
      },
    //   {
    //     field: "ct_comments",
    //     headerName: "Comments",
    //     headerAlign: "center",
    //     width: 200,
    //     renderCell: (params) => (
    //       <div
    //         onClick={() =>
    //           handleCommentsOpenDialog(params?.row?.id, params?.row?.ct_comments)
    //         }
    //       >
    //         <div
    //           style={{
    //             display: "flex",
    //             justifyContent: "flex-start",
    //             width: 200,
    //             gap: 5
    //           }}
    //         >
    //           <div
    //             style={{
    //               overflow: "hidden",
    //               textWrap: "nowrap",
    //               // textOverflow: "ellipsis",
    //             }}
    //           >
    //             {params?.row?.ct_comments?.toLowerCase() === "nan"
    //               ? ""
    //               : params?.row?.ct_comments}
    //           </div>
    //           <MoreHorizIcon />
    //         </div>
    //       </div>
    //     ),
    //   },
    ];
  
    // Handler for Bank Name Dropdown
    const handleBankNameDropdownChange = (name, value, reason) => {
      if (reason === "clear") {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value, Receiving_Bank_Account: null }));
        getBankAccountsList("")
      } else {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
        getBankAccountsList(value)
      }
    };
  
    const [banksList, setBanksList] = useState([])
    const [selectedBankAccount, setSelectedBankAccount] = useState("");
    const [entityList, setEntityList] = useState([]);
    const [currencyCodeList, setCurrencyCodeList] = useState([]);
    const getBanksList = async () => {
      const response = await instance.get("documents/get_all_unique_bank_names/")
      setBanksList(response?.data?.bank_names)
    }
  
    const getBankAccountsList = async (value) => {
      const response = await instance.get(`documents/get_all_unique_account_numbers_by_bank_name/?bank_name=${value}`)
      setSelectedBankAccount(response?.data?.account_numbers)
    }

    const getEntityList = async () => {
      const response = await instance.get("documents/get_all_entity_divisions/");
      setEntityList(response?.data?.entity_divisions);
    }

    const getCurrencyCodeList = async () => {
      const response = await instance.get("documents/get_all_currencies/");
      setCurrencyCodeList(response?.data?.currencies);
    }
  
    useEffect(() => {
      getBanksList()
      getBankAccountsList("")
      getEntityList()
      getCurrencyCodeList()
    }, [])  
  
    const handleCommentsOpenDialog = (currentRowId, currentRowCommentData) => {
      setOpenCommentsDialog(true);
      setCurrentRowId(currentRowId);
      // setDialogCommentsValue(currentRowCommentData);
      setOldConcatenatedComment(currentRowCommentData ?? "");
    };
  
    const handleCloseDialogs = () => {
      setOpenCommentsDialog(false);
      setDialogCommentsValue("");
      setCurrentRowId(null);
    };
  
    const handleDialogInputChange = (e) => {
      setDialogCommentsValue(e.target.value);
    };
  
    const handleSaveComments = () => {
      setOpenCommentsDialog(false);
      let updatedComment = ``;
      if (dialogCommentsValue) {
        let currentTimestamp = new Date();
        currentTimestamp = dayjs(currentTimestamp).format("DD-MM-YYYY HH:mm:ss");
        let newCommentString = `${currentTimestamp} - ${userData.user_name}\n${dialogCommentsValue}`;
        updatedComment = `${newCommentString}\n\n${oldConcatenatedComment}`;
      } else {
        updatedComment = `${oldConcatenatedComment}`;
      }
      console.log("updated comment", updatedComment);
  
      handleCommentsChange(updatedComment);
      handleCloseDialogs();
    };
  
    const handleCommentsChange = async (updatedComment) => {
      const payload = {
        // user_name: userData.user_name,
        id: currentRowId,
        ct_comments: updatedComment,
      };
      const response = await instance.patch(
        `bankmanagement/bank_reconciliation/${currentRowId}/`,
        payload
      );
      if (response.status === 201) {
        commonToast("success", "Comment successfully saved");
        loadData();
      } else {
        commonToast("error", "Comment could not be saved");
      }
    };
  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchBnkReconciliationList();
    }
  };

    // Handlers for checkbox filters - Single selection enforced
    const handleBankCheckboxChange = (bankName) => {
      setSelectedBanks((prev) => {
        if (prev.includes(bankName)) {
          // Deselect if already selected
          return prev.filter((b) => b !== bankName);
        } else {
          // Replace previous selection with new one (single selection)
          return [bankName];
        }
      });
    };

    const handleAccountCheckboxChange = (accountNo) => {
      setSelectedAccounts((prev) => {
        if (prev.includes(accountNo)) {
          // Deselect if already selected
          return prev.filter((a) => a !== accountNo);
        } else {
          // Replace previous selection with new one (single selection)
          return [accountNo];
        }
      });
    };

    const handleClearBankSearch = () => {
      setBankNameSearch("");
      setSelectedBanks([]);
    };

    const handleClearAccountSearch = () => {
      setAccountNoSearch("");
      setSelectedAccounts([]);
    };

    // Update account list when selected banks change
    useEffect(() => {
      if (selectedBanks.length > 0) {
        getBankAccountsList(selectedBanks[0]);
      } else {
        getBankAccountsList("");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBanks]);
  
    const handleBankTnxSelectAccountDropdown = (name, value, reason) => {
      if (reason === "clear") {
        setIsBankAccountNoDeSelected(true);
      } else {
        setIsBankAccountNoDeSelected(false);
        setSearchFieldsPrams({
          ...searchFieldsPrams,
          [name]: value ?? "",
        });
      }
    };

    const handleEntityDropdown = (name, value, reason) => {
      if (reason === "clear") {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value, Entity: "" }));
      } else {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
      }
    };

    const handleBankCurrencyDropdown = (name, value, reason) => {
      if (reason === "clear") {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value, Bank_Currency: "" }));
      } else {
        setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
      }
    };
  
    const searchQueryParams = () => {
      let getSearchQueryParams = "";
      const { Entity, Bank_Currency } = searchFieldsPrams;
  
      // Handle single bank name selection (only first one is sent to backend)
      if (selectedBanks.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&bankName=${selectedBanks[0]}`;
      }

      // Handle single account number selection (only first one is sent to backend)
      if (selectedAccounts.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&accountNo=${selectedAccounts[0]}`;
      }
  
      let formattedFromDateValue = "",
        formattedToDateValue = "";
  
      if (fromDateValue && toDateValue) {
        formattedFromDateValue = format(fromDateValue, "dd/MM/yyyy");
        formattedToDateValue = format(toDateValue, "dd/MM/yyyy");
        getSearchQueryParams = `${getSearchQueryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
      }

      if (Entity) {
        getSearchQueryParams = `${getSearchQueryParams}&entity_division=${Entity}`
      }

      if (Bank_Currency) {
        getSearchQueryParams = `${getSearchQueryParams}&currency_code=${Bank_Currency}`
      }
      return getSearchQueryParams;
    };
  
    const handleSearchBnkReconciliationList = async () => {
      try {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;
  
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
  
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
  
        const response = await instance.get(
          `${getBankReconciliationTable}${queryParams}`
        );

        const data = response.data;
        const secdata = data.summary;
        setTotalCreditAmount(secdata.total_credit_amount || 0.0);
        setTotalDebitAmount(secdata.total_debit_amount || 0.0);
        setTotalCashTrackerAmount(secdata.total_ca_rec_amount || 0.0);
        setTotalVariance(secdata.total_variance || 0.0);
  
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
  
        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ? response?.data?.data : [],
            page: 1,
          }));
          setIsSearchPerformed(true);
          setIsClearPerformed(false);
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count ?? 0,
            data: [],
          }));
          setPaginationCount(0);
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        console.log("err", err);
      }
    };
  
    // UseEffect
    useEffect(() => {
      if (isBankAccountNoDeSelected || isClearPerformed) {
        loadData();
      }
    }, [isBankAccountNoDeSelected, isClearPerformed]);
  
    useEffect(() => {
      if (!isBankAccountNoDeSelected) {
        loadData();
      }
    }, [pageState?.pageSize, pageState?.page]);
  
    return (
      <div style={Container}>
        <Box
          sx={{
            "& .MuiTab-root": {
              "&.Mui-selected": {
                backgroundColor: "#1672DE !important",
                color: "white !important",
              },
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
            {/* Filter Sidebar */}
            <CommonFilterSidebar
              isOpen={filterSidebarOpen}
              filterConfigs={[
                {
                  type: "bankName",
                  label: "Bank Name",
                  placeholder: "Search banks",
                  searchValue: bankNameSearch,
                  onSearchChange: setBankNameSearch,
                  items: banksList || [],
                  selectedItems: selectedBanks,
                  onItemChange: handleBankCheckboxChange,
                  onClear: handleClearBankSearch,
                  singleSelection: true, // Enable single selection mode
                },
                {
                  type: "accountNo",
                  label: "Account No",
                  placeholder: "Search accounts",
                  searchValue: accountNoSearch,
                  onSearchChange: setAccountNoSearch,
                  items: selectedBankAccount || [],
                  selectedItems: selectedAccounts,
                  onItemChange: handleAccountCheckboxChange,
                  onClear: handleClearAccountSearch,
                  singleSelection: true, // Enable single selection mode
                },
                {
                  type: "custom",
                  content: (
                    <>
                      <Typography
          sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                          marginBottom: "12px",
                        }}
                      >
                        Entity
                      </Typography>
              <div onKeyUp={(e) => handleEnter(e)}>
              <CommonSelect
                placeholder="Select Entity"
                value={searchFieldsPrams?.Entity ?? ""}
                handleChange={(event, value, reason) =>
                  handleEntityDropdown(
                    "Entity",
                    value,
                    reason,
                    event
                  )
                }
                options={entityList || []}
              />
              </div>
                    </>
                  ),
                },
                {
                  type: "custom",
                  content: (
                    <>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#000",
                          marginBottom: "12px",
                        }}
                      >
                        Bank Currency
                      </Typography>
              <div onKeyUp={(e) => handleEnter(e)}>
              <CommonSelect
                placeholder="Select Bank Currency"
                value={searchFieldsPrams?.Bank_Currency ?? ""}
                handleChange={(event, value, reason) =>
                  handleBankCurrencyDropdown(
                    "Bank_Currency",
                    value,
                    reason,
                    event
                  )
                }
                options={currencyCodeList || []}
              />
              </div>
                    </>
                  ),
                },
                {
                  type: "dateRange",
                  label: "Transaction Period",
                  startDate: fromDateValue,
                  setStartDate: setFromDateValue,
                  endDate: toDateValue,
                  setEndDate: setToDateValue,
                  maxDate: new Date(),
                  onKeyUp: handleEnter,
                },
              ]}
              onApplyFilters={handleSearchBnkReconciliationList}
              onClearFilters={handleClearSearchList}
              isLoading={pageState?.isLoading}
              isFilterDisabled={isFilterBtnDisable()}
            />

            {/* Main Content Area */}
            <Box className="main-content-area">
              {/* Top Row: Heading Section and Summary Table side by side */}
              <Box sx={{ display: "flex", gap: "20px", mb: 2, alignItems: "flex-start" }}>
                {/* Left: Heading Section */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px", minWidth: "300px" }}>
                  <Typography
                    variant="h5"
                    className="page-heading"
                  >
                    Bank Reconciliation
                  </Typography>
                  <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <RadioButtonCheckedIcon sx={{ color: "#1672DE", fontSize: "18px" }} />
                      <Typography variant="body2" sx={{ fontSize: "14px" }}>New Data</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <RadioButtonCheckedIcon sx={{ color: "#808080", fontSize: "18px" }} />
                      <Typography variant="body2" sx={{ fontSize: "14px" }}>Migrated Data</Typography>
                    </Box>
                  </Box>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      minHeight: "36px",
                      width: "fit-content",
                      "& .MuiTabs-indicator": {
                        display: "none",
                      },
                      "& .MuiTabs-flexContainer": {
                        width: "fit-content",
                      },
                    }}
                    aria-label="reconciliation tabs"
          >
            <Tab
              label="Show All"
                      sx={{
                        borderRight: "1px solid #e0e0e0",
                        backgroundColor: tabValue === 0 ? "#1672DE !important" : "transparent !important",
                        color: tabValue === 0 ? "white !important" : "#666 !important",
                        borderRadius: "6px 0 0 6px",
                        minHeight: "36px",
                        minWidth: "100px",
                        maxWidth: "100px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontWeight: tabValue === 0 ? "600" : "400",
                        "&:hover": {
                          backgroundColor: tabValue === 0 ? "#1565c0 !important" : "rgba(22, 114, 222, 0.05) !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#1672DE !important",
                          color: "white !important",
                        },
                      }}
                    />
            <Tab
              label="Variance"
                      sx={{
                        backgroundColor: tabValue === 1 ? "#1672DE !important" : "transparent !important",
                        color: tabValue === 1 ? "white !important" : "#666 !important",
                        borderRadius: "0 6px 6px 0",
                        minHeight: "36px",
                        minWidth: "100px",
                        maxWidth: "100px",
                        padding: "6px 16px",
                        textTransform: "none",
                        fontWeight: tabValue === 1 ? "600" : "400",
                        "&:hover": {
                          backgroundColor: tabValue === 1 ? "#1565c0 !important" : "rgba(22, 114, 222, 0.05) !important",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#1672DE !important",
                          color: "white !important",
                        },
              }}
            />
          </Tabs>
                </Box>

                {/* Right: Summary Table - Side by side with heading */}
                <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
                  <Box sx={{ 
                    p: 0, 
                    backgroundColor: "#ffffff", 
                    borderRadius: "12px", 
                    width: "100%",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                  }}>
                    <Table aria-label="summary table" sx={{ 
                      width: "100%", 
                      borderCollapse: "collapse",
                      "& .MuiTableCell-root": {
                        border: "none",
                      }
                    }}>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px",
                            "&:first-of-type": {
                              borderTopLeftRadius: "12px",
                            },
                            "&:last-of-type": {
                              borderTopRightRadius: "12px",
                            }
                          }} align="center">
                            Total Bank Stmt Amt (CR)
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            Total Bank Stmt Amt (DR)
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px"
                          }} align="center">
                            Total Amt on Cash Tracker
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px", 
                            backgroundColor: "#1672DE", 
                            color: "#ffffff",
                            fontWeight: "600",
                            fontSize: "14px",
                            "&:last-of-type": {
                              borderTopRightRadius: "12px",
                            }
                          }} align="center">
                            Total Variance
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {numberFormatter(totalCreditAmount)}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {numberFormatter(totalDebitAmount)}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {numberFormatter(totalCashTrackerAmount)}
                          </TableCell>
                          <TableCell sx={{ 
                            border: "none", 
                            padding: "12px 16px",
                            backgroundColor: "#ffffff",
                            fontSize: "14px",
                            fontWeight: "500"
                          }} align="center">
                            {numberFormatter(totalVariance)}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </Box>

                {/* Filter Toggle Button */}
                <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <IconButton
                    onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                    className="filter-toggle-button"
                  >
                    <FilterListIcon />
                  </IconButton>
                </Box>
              </Box>

              {/* DataGrid - Full width below */}
              <Box
                sx={{
                  flex: 1,
            display: "flex",
                  flexDirection: "column",
                  minHeight: 0,
                  position: "relative",
                  backgroundColor: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
                  overflow: "visible",
                  transition: "all 0.3s ease",
                  border: "1px solid #e8eaf0",
                  paddingBottom: "10px",
                  "&:hover": {
                    boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                  },
          }}
        >
          <DataGrid
            className={classes.pagination}
            loading={pageState?.isLoading}
            rows={pageState?.data ?? []}
            columns={columns}
            rowCount={pageState?.total}
            keepNonExistentRowsSelected
            disableSelectionOnClick
            pagination
            paginationMode="server"
            getRowId={(row) => row?.Payment_Receive_Date+row?.Receiving_Bank_Account}
            page={pageState.page - 1}
            pageSize={pageState?.pageSize ?? 25}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => {
              return setPageState((old) => {
                setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
                return { ...old, pageSize: newPageSize, page: 1 };
              });
            }}
            sx={{
                  border: "none",
                  flex: 1,
                  minHeight: 0,
                  "& .MuiDataGrid-root": {
                    border: "none",
                    height: "100%",
                  },
                  "& .MuiDataGrid-main": {
                    height: "100%",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e0e0e0",
                    minHeight: "52px !important",
                    maxHeight: "52px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    backgroundColor: "transparent",
                    fontWeight: "600",
                    color: "#1672DE",
                    fontSize: "14px",
                    padding: "12px 16px",
                    borderBottom: "none",
                    overflow: "visible",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "600",
                      fontSize: "14px",
                      overflow: "visible",
                      textOverflow: "clip",
                      whiteSpace: "normal",
                      lineHeight: "1.4",
                      width: "100%",
                    },
                    "& .MuiDataGrid-sortIcon": {
                      color: "#1672DE",
                    },
                    "& .MuiDataGrid-menuIcon": {
                      color: "#1672DE",
                    },
                  },
                  "& .MuiDataGrid-row": {
                    transition: "all 0.2s ease",
                    borderBottom: "1px solid #f0f0f0",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(22, 114, 222, 0.08)",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.12)",
                      },
                    },
                    "&:nth-of-type(even)": {
                      backgroundColor: "#fafafa",
                      "&:hover": {
                        backgroundColor: "rgba(22, 114, 222, 0.04)",
                      },
                    },
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 16px",
                    fontSize: "13px",
                    color: "#333",
                    display: "flex",
                    alignItems: "center",
                    "&:focus": {
                      outline: "none",
                    },
                    "&:focus-within": {
                      outline: "none",
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#1672DE",
                      borderRadius: "10px",
                      "&:hover": {
                        background: "#1565c0",
                      },
                    },
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "2px solid #e0e0e0",
                    backgroundColor: "#f8f9fa",
                    minHeight: "48px",
                    maxHeight: "48px",
                    paddingBottom: "8px",
                    paddingTop: "8px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    position: "relative",
                    zIndex: 1,
                  },
                  "& .MuiDataGrid-loadingOverlay": {
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                  },
                  "& .MuiDataGrid-columnHeader[data-field='ct_category']": {
                    width: "130px !important",
                    minWidth: "130px !important",
                    maxWidth: "130px !important",
                    padding: "12px 16px !important",
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                      width: "100%",
                      padding: 0,
                    },
                  },
                  "& .MuiDataGrid-cell[data-field='ct_category']": {
                    width: "130px !important",
                    minWidth: "130px !important",
                    maxWidth: "130px !important",
                    padding: "12px 16px !important",
                    "& .MuiDataGrid-cellContent": {
                      width: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: 0,
                    },
                  },
            }}
          />
          <Stack
                sx={{
              position: "absolute",
                  bottom: "16px",
                  right: "20px",
                  zIndex: 10,
                  backgroundColor: "#f8f9fa",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <CommonPaginationContainer
              count={paginationCount + 1}
              pageState={pageState}
              setPageState={setPageState}
            />
          </Stack>
              </Box>
            </Box>
      </Box>
        <Dialog open={openCommentsDialog} onClose={handleCloseDialogs}>
          <DialogTitle>Comment</DialogTitle>
          <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
            <TextareaAutosize
              minRows={5}
              value={dialogCommentsValue}
              onChange={handleDialogInputChange}
              className=""
              style={{ width: "350px", minWidth: "350px" }}
              // disabled={currentCommentsIndex!=selectedRowIndex}
            />
            {oldConcatenatedComment && (
              <div
                style={{
                  textWrap: "wrap",
                  backgroundColor: "rgb(175, 171, 170)",
                  marginTop: "10px",
                  padding: "20px",
                  borderRadius: "5px",
                  whiteSpace: "pre-wrap",
                  textAlign: "left",
                  maxHeight:"300px",
                  overflowY:"scroll",
                  maxWidth:"400px"
                }}
              >
                {oldConcatenatedComment}
              </div>
            )}
          </DialogContent>
  
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
            <CommonButton
              text="Save"
              handleClick={handleSaveComments}
              hoverColor="#1565c0"
              disabled={!dialogCommentsValue}
              sx={{
                backgroundColor: "#1672DE",
                color: "white",
                "&:hover": {
                  backgroundColor: "#1565c0",
                },
              }}
            />
          </DialogActions>
        </Dialog>
      </Box>
      </div>
    );
  };